module.exports = __webpack_public_path__ + "static/media/blog-1.47544746.svg";